<div class="search__body">
    <form [formGroup]="form" class="search__form">
        <select
            *ngIf="location === 'header'"
            class="search__categories"
            [attr.aria-label]="'category' | t:'Category'"
            formControlName="category"
            (focus)="closeSuggestion()"
        >
            <option value="all">{{ 'all-categories' | t:'All Categories' }}</option>
            <option
                *ngFor="let category of categories"
                [value]="category.slug"
                [innerHTML]="getCategoryName(category)"
            ></option>
        </select>
        <input
            class="search__input"
            name="search"
            [attr.placeholder]="'search-products' | t:'Search products'"
            [attr.aria-label]="'site-search' | t:'Site search'"
            type="text"
            autocomplete="off"
            formControlName="query"
            (keydown.escape)="escape.next()"
            (focus)="openSuggestion()"
            (keydown.enter)="onEnter()"
            #input
        >
        <button class="search__button search__button--type--submit" type="submit" (click)="onEnter()" [attr.title]="'search' | t:'Search'">
            <app-icon name="search-20" size="20"></app-icon>
        </button>
        <button
            *ngIf="location === 'mobile-header'"
            class="search__button search__button--type--close"
            type="button"
            (click)="closeButtonClick.next()"
        >
            <app-icon name="cross-20" size="20"></app-icon>
        </button>
        <div class="search__border"></div>
    </form>

    <div class="search__suggestions suggestions suggestions--location--{{ location }}">
        <ul class="suggestions__list">
            <li *ngFor="let product of suggestedProducts" class="suggestions__item">
                <div class="suggestions__item-image product-image">
                    <div class="product-image__body" *ngIf="product?.Image ">
                        <img class="product-image__img" [src]="product.Image" [alt]="product.Name">
                    </div>
                </div>

                <div class="suggestions__item-info">
                    <a [routerLink]="root.product(product)" [state]="product.ShowcaseVariant ? {showcaseVariant: product.ShowcaseVariant} : undefined" class="suggestions__item-name" (click)="closeSuggestion()">
                        {{ product | productName }}
                    </a>
                    <div class="suggestions__item-meta">{{ product.CategorySlug }}</div>
                </div>
                <!-- The price the product's card and page show in the visitor's country (cardPrice). -->
                <div class="suggestions__item-price" style="color: var(--ph-primary);">
                    {{ ((product | cardPrice | async) || product).Price|currencyFormat }}
                </div>

                <!-- *ngIf="location === 'header'" -->
                <div *ngIf="false" class="suggestions__item-actions"> 
                    <button
                        type="button"
                        [attr.title]="'add-to-cart' | t:'Add to cart'"
                        class="btn btn-primary btn-sm btn-svg-icon"
                        [class.btn-loading]="addedToCartProducts.includes(product)"
                        (click)="addToCart(product)">
                        <app-icon name="cart-16" size="16"></app-icon>
                    </button>
                </div>
            </li>
        </ul>
    </div>
</div>
